<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-tabs v-model="model" dark centered color="indigo" slider-color="cyan">
        <v-tab :href="`#tab-1`">
          <v-icon>person</v-icon>Estructura organizacional
        </v-tab>
        <v-tab :href="`#tab-2`"> <v-icon>person</v-icon>Personas </v-tab>
        <v-tab :href="`#tab-3`"> <v-icon>domain</v-icon>Unidades </v-tab>
      </v-tabs>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <ArbolUnidades
              v-if="!!dependencia_superior"
              :dependencia_superior="dependencia_superior"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card flat>
            <SliderPersonas v-if="!!dependencia_superior" :filtros="filtros" />
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <v-card flat>
            <EstructuraOrganizacional
              v-if="!!dependencia_superior"
              :filtros="filtros"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import SliderPersonas from "./components/SliderPersonas.vue";
import EstructuraOrganizacional from "./components/EstructuraOrganizacional.vue";
import ArbolUnidades from "./components/ArbolUnidades.vue";
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Definición de componentes importados
  components: { SliderPersonas, EstructuraOrganizacional, ArbolUnidades },
  // Variables iniciales del componente
  data() {
    return {
      lista_servidores: [],
      loading: false,
      model: "tab-1",
      user: this.$storage.get("user"),
      dependencia_superior: null,
      filtros: {}
    };
  },
  async created() {
    this.dependencia_superior = await this.obtieneDependenciaUnidad(
      this.user.unidad[0].id
    );
    // Preguntamos si es la dependencia superior 1 (Despacho) para mostrar todo o no
    if (this.dependencia_superior.nivel_org != 1) {
      this.filtros = { id_dependencia: this.dependencia_superior.id };
    }
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para obtener dependencia de una unidad
    async obtieneDependenciaUnidad(id_unidad) {
      // Preguntamos que nivel tiene la unidad del usuario para listar solo su dependencia o todo
      try {
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "select control.fn_obtiene_dependencia_superior_json(${id_unidad})"){
                  respuesta
                }
              }
            `
        });
        return JSON.parse(
          res.runQuery.respuesta[0].fn_obtiene_dependencia_superior_json
        );
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para ordenar la tabla

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  }
};
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
#cabecera_tabla {
  background: rgb(250, 252, 253);
  font-weight: bold;
  color: rgb(88, 85, 85);
}
.filtro {
  padding: 0;
  margin: 0;
  max-width: 100%;
}
.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes_lista_personal/ListaPersonalActivo.vue